<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navbar</strong>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/navbar"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-navbar expandable="md" color="info">
          <c-toggler in-navbar @click="show = !show" />
          <c-navbar-brand href="#">NavBar</c-navbar-brand>
          <c-collapse :show="show" navbar>
            <c-navbar-nav>
              <c-nav-item href="#">Link</c-nav-item>
              <c-nav-item href="#" disabled>Disabled</c-nav-item>
            </c-navbar-nav>

            <!-- Right aligned nav items -->
            <c-navbar-nav class="ml-auto">
              <c-form inline class="align-middle">
                <c-input class="mr-2 my-0" placeholder="Search" size="sm" />
                <c-button color="light" size="sm">
                  Search
                </c-button>
              </c-form>

              <c-dropdown toggler-text="Lang" in-nav>
                <c-dropdown-item>EN</c-dropdown-item>
                <c-dropdown-item>ES</c-dropdown-item>
                <c-dropdown-item>RU</c-dropdown-item>
                <c-dropdown-item>FA</c-dropdown-item>
              </c-dropdown>

              <c-dropdown in-nav toggler-text="User">
                <c-dropdown-item>Profile</c-dropdown-item>
                <c-dropdown-item>Signout</c-dropdown-item>
              </c-dropdown>
            </c-navbar-nav>
          </c-collapse>
        </c-navbar>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Navbar</strong>
        <small>brand</small>
      </c-card-header>
      <c-card-body>
        <!-- Image and text -->
        <c-navbar color="faded" light>
          <c-navbar-brand href="#">
            <img src="https://placekitten.com/g/30/30" class="d-inline-block align-top" alt="CoreuiVue" />
            CoreuiVue
          </c-navbar-brand>
        </c-navbar>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Navbar</strong>
        <small>text</small>
      </c-card-header>
      <c-card-body>
        <c-navbar toggleable="sm" light color="light">
          <c-toggler in-navbar @click="navbarText = !navbarText" />
          <c-navbar-brand>CoreuiVue</c-navbar-brand>
          <c-collapse :show="navbarText" navbar>
            <c-navbar-nav>
              <c-navbar-text>Navbar text</c-navbar-text>
            </c-navbar-nav>
          </c-collapse>
        </c-navbar>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Navbar</strong>
        <small>dropdown</small>
      </c-card-header>
      <c-card-body>
        <c-navbar expandable="sm" color="primary">
          <c-toggler in-navbar @click="navbarDropdown = !navbarDropdown" />
          <c-collapse :show="navbarDropdown" navbar>
            <c-navbar-nav>
              <c-nav-item href="#">Home</c-nav-item>
              <c-nav-item href="#">Link</c-nav-item>
              <!-- Navbar dropdowns -->
              <c-dropdown toggler-text="Lang" in-nav>
                <c-dropdown-item>EN</c-dropdown-item>
                <c-dropdown-item>ES</c-dropdown-item>
                <c-dropdown-item>RU</c-dropdown-item>
                <c-dropdown-item>FA</c-dropdown-item>
              </c-dropdown>
              <c-dropdown toggler-text="User" in-nav>
                <c-dropdown-item>Account</c-dropdown-item>
                <c-dropdown-item>Settings</c-dropdown-item>
              </c-dropdown>
            </c-navbar-nav>
          </c-collapse>
        </c-navbar>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Navbar</strong>
        <small>form</small>
      </c-card-header>
      <c-card-body>
        <c-navbar light color="light">
          <c-form inline>
            <c-input class="mr-sm-2" placeholder="Search" size="sm" />
            <c-button color="outline-success" class="my-2 my-sm-0" type="submit">Search</c-button>
          </c-form>
        </c-navbar>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Navbar</strong>
        <small>input group</small>
      </c-card-header>
      <c-card-body>
        <c-navbar light color="light">
          <c-form inline>
            <c-input class="mr-sm-2" placeholder="Username" />
          </c-form>
        </c-navbar>
      </c-card-body>
    </c-card>
  </div>
</template>
<script>
export default {
  name: 'Navbars',
  data() {
    return {
      show: false,
      navbarText: false,
      navbarDropdown: false,
    };
  },
};
</script>
